import React from 'react';
import { TrendingUp, ShieldCheck, DollarSign } from 'lucide-react';
export function ValueProposition() {
  const benefits = [{
    icon: TrendingUp,
    title: 'Sichtbarkeit erhöhen',
    description: 'Heben Sie sich von der Masse ab mit professionellen Bildern, die Ihre Expertise und Persönlichkeit unterstreichen.'
  }, {
    icon: ShieldCheck,
    title: 'Vertrauen aufbauen',
    description: 'Authentische Fotos schaffen Nähe und Glaubwürdigkeit – die Basis für jede erfolgreiche Geschäftsbeziehung.'
  }, {
    icon: DollarSign,
    title: 'Umsatz steigern',
    description: 'Hochwertige visuelle Kommunikation zieht die richtigen Kunden an und rechtfertigt Premium-Preise.'
  }];
  return <section className="py-20 bg-white" data-id="element-141">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16" data-id="element-143">
          {benefits.map((benefit, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-144">
              <div className="mb-6 p-4 rounded-full bg-[#D4A574]/10 text-[#D4A574] group-hover:bg-[#D4A574] group-hover:text-white transition-colors duration-300" data-id="element-145">
                <benefit.icon className="h-10 w-10" strokeWidth={1.5} data-id="element-146" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-147">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-148">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}